/**
 * Drew's Boots - Custom JS
 * Use this file for any future custom functionality.
 */

if (!window.customScriptLoaded) {
    window.customScriptLoaded = true;
    document.addEventListener('DOMContentLoaded', function() {
        // Your code here
    });
}